import request from "@/utils/request";


// 根据告警ID获取告警历史记录/告警工单信息
export function getDeptAlarmDetails(data) {
  return request({
    url: "trajectory-service/deptAlarm/getTaskByAlarmId",
    method: "get",
    params: data,
  });
}
// 清除告警状态
export function clearAlarmStatus(alarmId) {
  return request({
    url: "alarm-service/alarm/clearAlarmStatus?alarmId=" + alarmId,
    method: "post",
  });
}


// 获取告警设备类型列表
export function getAlarmDeviceTypeList() {
  return request({
    url: "alarm-service/alarm/getAlarmDeviceTypeList",
    method: "get",
  });
}


// 获取告警列表
export function getAlarmList(data) {
  return request({
    url: "alarm-service/alarm/getAlarmList",
    method: "get",
    params: data,
  });
}

// 获取提示告警列表
export function getTipAlarmList(data) {
  return request({
    url: "alarm-service/alarm/getTipAlarmList",
    method: "get",
    params: data,
  });
}


// 更新告警阅读状态
export function updateAlarmReadStatus(data) {
  return request({
    url: "alarm-service/alarm/updateAlarmReadStatus",
    method: "post",
    params: data,
  });
}

// 根据筛选条件查询设备操作信息
export function getDeviceLogList(data) {
  return request({
    url: 'device-service/deviceLog/getDeviceLogList',
    method: 'get',
    params: data
  })
}



 
// 查询故障等级状态-告警等级占比
export function getAlarmLevel(data) {
  return request({
    url: 'alarm-service/statistics/getAlarmLevel',
    method: 'get',
    params: data
  })
}

 
// 查询故障等级设备类型状态-告警等级分布
export function getAlarmLevelType(data) {
  return request({
    url: 'alarm-service/statistics/getAlarmLevelType',
    method: 'get',
    params: data
  })
}
 

// 查询故障状态-告警状态占比
export function getAlarmStatus(data) {
  return request({
    url: 'alarm-service/statistics/getAlarmStatus',
    method: 'get',
    params: data
  })
} 


// 查询故障设备类型等级状态-设备告警等级分布
export function getAlarmTypeLevel(data) {
  return request({
    url: 'alarm-service/statistics/getAlarmTypeLevel',
    method: 'get',
    params: data
  })
}


// 查询故障设备类型状态-告警状态分布
export function getAlarmTypeStatus(data) {
  return request({
    url: 'alarm-service/statistics/getAlarmTypeStatus',
    method: 'get',
    params: data
  })
}

